import { render, staticRenderFns } from "./BillLayout.vue?vue&type=template&id=c7a66140&scoped=true&"
import script from "./BillLayout.vue?vue&type=script&lang=js&"
export * from "./BillLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a66140",
  null
  
)

export default component.exports